export default __webpack_public_path__ + "static/media/levelIcon.6ddbc5d5.svg";